import React from "react";
import { Button, ButtonProps, Modal } from "react-bootstrap";

import "../../../css/modal-custom.css";
import t from "../../i18n/i18next";

export type ISimpleModalButtonProps<T> = ButtonProps & {
    text: string;
    customValue: T;
};

export type ISimpleModalProps<T> = {
    children: React.ReactNode;
    show: boolean;
    scroll?: boolean;
    size?: string;
    title: string;
    footer?: React.JSX.Element;
    buttons?: ISimpleModalButtonProps<T>[];
    onEntered?: (node: HTMLElement) => void;
    onRequestClose: (value: T | undefined) => void;
};

const SimpleModal = <T,>(props: ISimpleModalProps<T>) => {
    const entered = (node: HTMLElement) => {
        if (props.onEntered) {
            props.onEntered(node);
        }
    };

    const close = () => {
        if (props.onRequestClose) {
            props.onRequestClose(undefined);
        }
    };

    let dialogClassName = "";
    let bsSize;
    switch (props.size) {
        case "halfscreen":
        case "half-screen":
        case "half":
            dialogClassName = " modal-dialog-halfscreen";
            break;
        case "fullscreen":
        case "full-screen":
        case "full":
            dialogClassName = " modal-dialog-fullscreen";
            break;
        case "halfwidth":
        case "half-width":
            dialogClassName = "modal-dialog-halfwidth";
            break;
        case "fullwidth":
        case "full-width":
            dialogClassName = "modal-dialog-fullwidth";
            break;
        default:
            bsSize = props.size;
            break;
    }

    if (props.scroll) {
        dialogClassName += " modal-dialog-scrollable";
    }

    dialogClassName = dialogClassName.trim();
    if (dialogClassName.length === 0) {
        dialogClassName = undefined;
    }

    let footer: React.JSX.Element;
    if (props.footer) {
        footer = props.footer;
    } else {
        let buttonsElement;
        if (props.buttons) {
            buttonsElement = props.buttons.map((item, index) => {
                const callback = () => props.onRequestClose(item.customValue);
                return (
                    <Button
                        key={index}
                        onClick={callback}
                        variant={item.variant}
                        size={item.size}
                    >
                        {t(item.text)}
                    </Button>
                );
            });
        } else {
            buttonsElement = [
                <Button key={0} variant="light" size="sm" onClick={close}>
                    {t("Close")}
                </Button>,
            ];
        }

        footer = <Modal.Footer>{buttonsElement}</Modal.Footer>;
    }

    return (
        <Modal
            show={props.show}
            animation
            backdrop="static"
            onEnter={entered}
            onHide={close}
            size={bsSize}
            dialogClassName={dialogClassName}
        >
            <Modal.Header closeButton>
                <Modal.Title>{props.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{props.children}</Modal.Body>
            {footer}
        </Modal>
    );
};

export default SimpleModal;
